module.exports = require("@material-ui/lab/Alert");